/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-use-before-define */
export const isWeiBo = () => navigator.userAgent.match(/weibo/);

// 判断是否为qq和微信
export const isWeiXinAndQQ = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  if (isWeiXin() || isQQ()) {
    return true;
  }
  return false;
};

export const isWeiXin = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i)) {
    return true;
  }
  return false;
};

// 判断是否为qq和qq浏览器
export const isQQ = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/\sQQ/i)) {
    return true;
  }
  return false;
};
export const isIos = () => {
  const u = window.navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
};
export const isAndroid = () => {
  const u = navigator.userAgent;
  return u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
};


export const IsMobile = () => isIos() || isAndroid();

export const bornPrice=(num)=>{
  num=Math.abs(num)
  const firstNum=parseInt(num);
  let lastNum=Number(((Number(num)*100)%100).toFixed(0));
  if(lastNum==0){
    lastNum= ".00"
  }else if(lastNum>9){
    lastNum= `.${lastNum}`
  }else{
    lastNum =`.0${lastNum}`
  }
  return `${firstNum}${lastNum}`
}
//价格调整
export const bornSmallNumber=(num)=>{
  const lastNum=Number(((Number(num)*100)%100).toFixed(0));
  if(lastNum==0){
    return ".00"
  }else if(lastNum>9){
    return `.${lastNum}`
  }else{
    return `.0${lastNum}`
  }
}
export const getShopName = (type) => {
  switch (type) {
    case "tb":
      return "淘宝";
    case "jd":
      return "京东自营";
    case "pdd":
      return "拼多多";
    default:
      return "精选";
  }
};
export const jumpHandle = (urlScheme, link) => {
  let visible = true;
  let timeout = null;
  let startTime = 0;
  const handle = () => {
      if (document.visibilityState === "hidden") {
          startTime = new Date().getTime();
          if (timeout) {
              clearTimeout(timeout);
              timeout = null;
          }
          visible = false;
      }
      if (document.visibilityState === "visible") {
          document.removeEventListener("visibilitychange", handle);
          if ((new Date().getTime() - startTime) < 300 && isAndroid()) {
              window.location.href = link;
          }
          visible = false;
      }
  }
  document.addEventListener("visibilitychange", handle);
  const iframe = document.createElement("iframe");
  iframe.style.visibility = "hidden";
  iframe.style.width = 0;
  iframe.style.height = 0;
  iframe.src = urlScheme;
  iframe.onerror = () => (window.location.href = link);
  document.body.appendChild(iframe);
  timeout = setTimeout(() => {
      if (visible) window.location.href = link;
  }, 2000);
}